export default {
  Arise: 'Arise',
  System: 'System',
  Required: 'Required',
  EditVersion: 'EditVersion',
  Duplicate: 'Duplicate'
};
